import * as styles from "./Skeleton.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { SkeletonProps } from "./Skeleton.types";

export function Skeleton({
  effect = "shimmer",
  radius = "md",
  className,
  ...props
}: SkeletonProps): JSX.Element {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={clsx(styles.skeleton({ effect, radius }), className)}
      {...props}
    />
  );
}
